var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "login-wrapper"
  }, [_vm._m(0), _c("div", {
    staticClass: "login-right"
  }, [_vm._m(1), _c("div", {
    staticClass: "form-container"
  }, [_vm._m(2), _c("el-form", {
    ref: "loginForm",
    staticClass: "login-form",
    attrs: {
      model: _vm.loginForm,
      rules: _vm.loginRules,
      autocomplete: "on",
      "label-position": "left"
    },
    nativeOn: {
      submit: function ($event) {
        $event.preventDefault();
      },
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        _vm.step === "request" ? _vm.handleRequestOtp() : _vm.handleVerifyOtp();
      }
    }
  }, [_c("transition", {
    attrs: {
      name: "step-fade",
      mode: "out-in"
    }
  }, [_vm.step === "request" ? _c("div", {
    key: "request"
  }, [_c("el-form-item", {
    staticClass: "form-group",
    attrs: {
      prop: "mobileNumber"
    }
  }, [_c("label", {
    staticClass: "form-label"
  }, [_vm._v("Phone Number")]), _c("el-input", {
    ref: "mobileNumber",
    staticClass: "minimal-input",
    attrs: {
      placeholder: _vm.$t("login.mobile"),
      name: "mobileNumber",
      type: "text",
      autocomplete: "on",
      "prefix-icon": "el-icon-mobile-phone",
      maxlength: "10"
    },
    model: {
      value: _vm.loginForm.mobileNumber,
      callback: function ($$v) {
        _vm.$set(_vm.loginForm, "mobileNumber", $$v);
      },
      expression: "loginForm.mobileNumber"
    }
  })], 1), _c("el-button", {
    staticClass: "login-button",
    attrs: {
      loading: _vm.loading,
      type: "primary"
    },
    nativeOn: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.handleRequestOtp.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("login.requestOtp")) + " ")])], 1) : _c("div", {
    key: "verify"
  }, [_c("div", {
    staticClass: "sent-to-info"
  }, [_c("span", {
    staticClass: "info-text"
  }, [_vm._v("OTP sent to +91 " + _vm._s(_vm.loginForm.mobileNumber))]), _c("el-button", {
    staticClass: "edit-btn",
    attrs: {
      type: "text"
    },
    on: {
      click: _vm.backToRequest
    }
  }, [_vm._v(" Edit ")])], 1), _c("div", {
    staticClass: "form-group"
  }, [_c("label", {
    staticClass: "form-label"
  }, [_vm._v("OTP")]), _c("div", {
    staticClass: "otp-boxes",
    class: {
      "otp-boxes--error": _vm.otpError
    }
  }, _vm._l(_vm.otpDigits, function (digit, index) {
    return _c("input", {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.otpDigits[index],
        expression: "otpDigits[index]"
      }],
      key: index,
      ref: "otpBox" + index,
      refInFor: true,
      staticClass: "otp-box",
      attrs: {
        type: "text",
        inputmode: "numeric",
        pattern: "[0-9]*",
        maxlength: "1",
        autocomplete: "one-time-code"
      },
      domProps: {
        value: _vm.otpDigits[index]
      },
      on: {
        input: [function ($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.otpDigits, index, $event.target.value);
        }, function ($event) {
          return _vm.onOtpInput(index, $event);
        }],
        keydown: function ($event) {
          return _vm.onOtpKeydown(index, $event);
        },
        paste: function ($event) {
          return _vm.onOtpPaste($event);
        }
      }
    });
  }), 0), _vm.otpError ? _c("span", {
    staticClass: "otp-error-text"
  }, [_vm._v(_vm._s(_vm.otpError))]) : _vm._e()]), _c("div", {
    staticClass: "resend-container"
  }, [_vm.countdown > 0 ? _c("span", {
    staticClass: "countdown-text"
  }, [_vm._v("Resend OTP in " + _vm._s(_vm.countdown) + "s")]) : _c("el-button", {
    staticClass: "resend-btn",
    attrs: {
      type: "text"
    },
    on: {
      click: _vm.resendOtp
    }
  }, [_vm._v(" Resend OTP ")])], 1)])])], 1)], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "login-left"
  }, [_c("div", {
    staticClass: "brand-container"
  }, [_c("div", {
    staticClass: "logo-wrapper"
  }, [_c("img", {
    staticClass: "logo-image",
    attrs: {
      src: require("@/assets/img/logo.png"),
      alt: "Logo"
    }
  })]), _c("p", {
    staticClass: "brand-tagline"
  }, [_vm._v(" Access your secure account and manage your business ")]), _c("div", {
    staticClass: "brand-features"
  }, [_c("div", {
    staticClass: "feature-item"
  }, [_c("div", {
    staticClass: "feature-icon"
  }, [_vm._v(" 🔒 ")]), _c("span", [_vm._v("Enterprise Grade Security")])]), _c("div", {
    staticClass: "feature-item"
  }, [_c("div", {
    staticClass: "feature-icon"
  }, [_vm._v(" ⚡ ")]), _c("span", [_vm._v("Lightning Fast Performance")])]), _c("div", {
    staticClass: "feature-item"
  }, [_c("div", {
    staticClass: "feature-icon"
  }, [_vm._v(" 🌐 ")]), _c("span", [_vm._v("Access From Anywhere")])])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "nova-background"
  }, [_c("div", {
    staticClass: "nova-circle nova-1"
  }), _c("div", {
    staticClass: "nova-circle nova-2"
  }), _c("div", {
    staticClass: "nova-circle nova-3"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-header"
  }, [_c("h2", {
    staticClass: "form-title"
  }, [_vm._v(" Agent Login ")]), _c("p", {
    staticClass: "form-subtitle"
  }, [_vm._v(" Enter your credentials to access your account ")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };